import styled, { css } from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../../../config/themes/variables/mediaqueries';

import { TabsHorizontal, TabHorizontal } from '../../../../core/TabsHorizontal';
import { AccordionTable } from '../../../../core/AccordionTable';
import Icon from '../../../../core/Icon';
import Input from '../../../../core/Input';
import Label from '../../../../core/Label';
import RadioButton from '../../../../core/RadioButton';
import { StyledTitle } from '../../../../core/TitleGivens/style';
import Button from '../../../../core/Buttons';
import DropdownInput from '../../../../core/DropdownInput';
import { Checkbox, CheckboxReverse } from '../../../../core/Checkbox';

import { DateSelector } from '../../../SearchByDate';
import { StyledFormColumn, StyledFormLabel } from '../style';
import { TwoLevelBreadcrumb } from '../index';

const StyledFormWrapper = styled.div`
  padding: 0 ${rem('15px')} ${rem('30px')};
  ${mediaqueries.greaterThan('desktop')`
    padding: 0;
  `};
`;

const StyledTwoLevelBreadcrumb = styled(TwoLevelBreadcrumb)`
  margin: 0 0 1.25rem;
`;

const StyledMain = styled.div`
  background-color: ${props => props.theme.colors.light};
  overflow: hidden;
  .IRPFForm-gender {
    max-width: ${rem('55px')};
  }
`;

const StyledTabsHorizontal = styled(TabsHorizontal)`
  display: block;
  margin-bottom: ${rem('40px')};
`;

const StyledTabHorizontal = styled(TabHorizontal)``;

const StyledAccordionTable = styled(AccordionTable)`
  margin: ${rem('40px')} auto ${rem('20px')};
`;

const StyledAlignRight = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 0 ${rem('-10px')};
  button {
    margin: 0 ${rem('10px')};
  }
`;

const StyledBeadcrumb = styled.div`
  display: flex;
  align-items: baseline;
  margin: ${rem('20px')};
  font-size: ${rem('16px')};
  flex-wrap: wrap;
  line-height: 1.2;
`;
const StyledBeadcrumbIcon = styled(Icon)`
  width: ${rem('6px')};
  height: ${rem('12px')};
  margin: 0 ${rem('7px')};
`;
const StyledBeadcrumbPrimary = styled.span`
  font-weight: bold;
`;

const StyledBox = styled.div`
  margin: 0 0 ${rem('30px')};
  ${mediaqueries.greaterThan('desktop')`
    margin-bottom: ${rem('40px')};
  `};
`;

const TitleButton = styled(StyledTitle)`
  border: ${rem('1px')} solid ${props => props.theme.colors.grayLight};
  font-family: ${props => props.theme.fonts.bold};
  font-size: ${props => props.theme.fontSize.xsmall};
  line-height: ${rem('15px')};
  margin: 0;
  padding: ${rem('6px')} ${rem('10px')};
  text-transform: uppercase;
  background: ${props => props.theme.colors.grayLightest};
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  span {
    max-width: 95%;
  }
  button {
    display: none;
    ${mediaqueries.greaterThan('desktop')`
      display: block;
      padding: ${rem('6px')} ${rem('9px')};
    `};
  }
  ${mediaqueries.greaterThan('desktop')`
    border: 0;
    border-bottom: ${rem('2px')} solid ${props => props.theme.colors.dark};
    background: white;
    font-family: ${props => props.theme.fonts.medium};
    font-size: ${props => props.theme.fontSize.small};
    padding: ${rem('6px')} 0;
  `};
  svg {
    margin-right: 0;
  }
`;

const StyledList = styled.ul`
  margin: 0;
  padding-left: 0;
  ${mediaqueries.greaterThan('desktop')`
    border-top: ${rem('1px')} solid ${props => props.theme.colors.grayLighter};
  `};
`;

const StyledElements = styled.div`
  background-color: ${props => props.theme.colors.grayMoreLight};
  margin-bottom: ${rem('5px')};
  padding: ${rem('14px')} ${rem('10px')} ${rem('20px')} ${rem('10px')};
  border: ${rem('1px')} solid ${props => props.theme.colors.grayLighter};
  &:first-child {
    border-top: 0 none;
  }
  :before {
    content: none;
  }
  ${mediaqueries.greaterThan('desktop')`
    border-top: 0;
    margin: 0;
    padding: ${rem('13px')} ${rem('20px')} ${rem('13px')} ${rem('10px')};
  `};
`;

const StyledRepeatedElements = styled.div`
  padding: 0;
  border: 0;
  margin-bottom: ${rem('20px')};
  border: ${rem('1px')} solid ${props => props.theme.colors.grayLighter};
  &:first-child {
    border-top: 0 none;
  }
  ${mediaqueries.greaterThan('desktop')`
    padding: 0;
  `};
`;

const StyleBoxForm = styled.div`
  ${mediaqueries.greaterThan('desktop')`
    align-items: center;
    display: flex;
    justify-content: space-between;
    `};
`;

const StyleInput = styled(Input)`
  width: auto;
  flex: 1;
  max-width: ${rem('258px')};
  ${mediaqueries.greaterThan('mobile')`
    max-width: ${rem('290px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    flex-shrink: 0;
    width: ${rem('160px')};
  `};
`;

const StyledLabel = styled(Label)`
  line-height: 1.25rem;
  font-size: 0.875rem;
`;

const StyledRadioButton = styled(RadioButton)`
  flex-wrap: wrap;
  ${mediaqueries.greaterThan('desktop')`
      flex-wrap: nowrap;
      width: 100%;
  `};
  label {
    padding-left: 0;
    order: -1;
    flex: initial;
    margin-bottom: ${rem('15px')};
    width: 100%;
    ${mediaqueries.greaterThan('desktop')`
        flex: 1;
        padding-right: 0.5rem;
        margin-bottom: 0;
        width: auto;
    `};
  }
`;

const StyledDateSelector = styled(DateSelector)`
  width: 100%;
  justify-content: flex-start;
  ${mediaqueries.greaterThan('460px')`
    width: auto;
  `};
  ${mediaqueries.greaterThan('desktop')`
    width: auto;
    min-width: 290px;
    justify-content: space-between;
  `};
`;

const StyledForm = styled.div`
  display: block;
  margin: 0 auto;
  background-color: ${props => props.theme.colors.grayMoreLight};
  padding: ${rem('15px')};
  ${mediaqueries.greaterThan('mobile')`
    display: flex;
    flex-wrap: wrap
  `};
`;

const StyledDateContainer = styled(StyledFormColumn)`
  ${StyledFormLabel} {
    width: 100%;
    margin-bottom: ${rem('5px')};
    ${mediaqueries.greaterThan('460px')`
      width: 110px;
      margin-bottom: 0;
    `};
    ${mediaqueries.greaterThan('mobile')`
      width: auto;
      margin-bottom: ${rem('5px')};
    `};
    ${mediaqueries.greaterThan('980px')`
      width: 110px;
      margin-bottom: 0;
      
    `};
  }
  &.endDate {
    width: 100%;
    ${mediaqueries.greaterThan('mobile')`
      width: 50%;
    `};
  }
`;

const StyledFormBottom = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  background: #fbfbfb;
  padding: 0 ${rem('30px')} ${rem('30px')} ${rem('15px')};
`;

const StyledFormLeyend = styled.div`
  margin-top: ${rem('20px')};
  display: block;
  ${mediaqueries.greaterThan('desktop')`
    flex: 1;
  `};
`;

const StyledLeyendText = styled.p`
  font-family: ${props => props.theme.fonts.bookItalic};
  font-size: ${props => props.theme.fontSize.xsmall};
  line-height: ${rem('15px')};
  margin: 0 0 ${rem('10px')};
  &:last-child {
    margin: 0;
  }
`;

const StyledLeyendNum = styled.span`
  font-family: ${props => props.theme.fonts.bold};
`;

const StyledButtonAdd = styled(Button)`
  padding: 0.75rem;
  > svg {
    margin-right: 0;
  }
  ${mediaqueries.greaterThan('desktop')`
    display: none;
  `};
`;

const StyledButtonDelete = styled(Button)`
  padding: ${rem('5px')};
  align-self: flex-end;
  margin-left: ${rem('15px')};
  > svg {
    margin: 0;
  }
`;

const StyledCol = styled.div`
  width: 100%;
  ${mediaqueries.greaterThan('mobile')`
    width: 50%;
  `};
`;

const StyledDropdownInput = styled(DropdownInput)`
  width: ${rem('204px')};
`;

const StyledCheckbox = styled(Checkbox)`
  margin-right: ${rem('20px')};
  label {
    font-size: ${rem('14px')};
    margin-left: ${rem('10px')};
    line-height: ${rem('19px')};
  }
`;

const StyledDateSelectorContainer = styled.div`
  ${mediaqueries.greaterThan('desktop')`
    text-align: right;
  `};
`;

const StyledClearLink = styled.span`
  font-size: ${rem('12px')};
  margin-top: ${rem('10px')};
  font-family: ${props => props.theme.fonts.medium};
  display: inline-block;
  cursor: pointer;
`;

const StyledCheckboxReverse = styled(CheckboxReverse)`
  label {
    font-size: ${rem('14px')};
    line-height: ${rem('19px')};
  }
`;

const StyledAdviseDate = styled.p`
  font-size: ${rem('14px')};
  ${props =>
    props.disabledDate &&
    css`
      color: ${props.theme.colors.gray};
      cursor: default;
    `}
`;

export {
  StyledMain,
  StyledTabsHorizontal,
  StyledTabHorizontal,
  StyledAccordionTable,
  StyledAlignRight,
  StyledBeadcrumb,
  StyledBeadcrumbIcon,
  StyledBeadcrumbPrimary,
  StyledRadioButton,
  StyledLabel,
  StyleInput,
  StyleBoxForm,
  StyledElements,
  StyledRepeatedElements,
  StyledList,
  TitleButton,
  StyledBox,
  StyledDateContainer,
  StyledDateSelector,
  StyledFormBottom,
  StyledFormLeyend,
  StyledLeyendNum,
  StyledLeyendText,
  StyledButtonAdd,
  StyledButtonDelete,
  StyledForm,
  StyledCol,
  StyledDropdownInput,
  StyledCheckbox,
  StyledCheckboxReverse,
  StyledDateSelectorContainer,
  StyledClearLink,
  StyledTwoLevelBreadcrumb,
  StyledFormWrapper,
  StyledAdviseDate
};
